<!--
 * @Description: 国安网站
 * @Author: zml
 * @Date: 2023-07-21 09:34:18
 * @LastEditors: zml
 * @LastEditTime: 2025-03-24 09:39:27
-->
<template>
  <div class="bgOne">
    <el-container>
      <el-header height="auto">
        <layout-header></layout-header>
      </el-header>
      <el-main>
        <keep-alive include="pageHome">
          <router-view></router-view>
        </keep-alive>
      </el-main>
      <el-footer height="auto">
        <layoutFooter></layoutFooter>
      </el-footer>
    </el-container>
    <el-backtop></el-backtop>
    <!-- <div class="fixed-box">
      <div class="fixed">
        <div class="side-fixed">
          <div class="btn" @click="$router.push('/contact')">
            <div class="msg">
              <i class="el-icon-chat-dot-round"></i>
              <div>{{ $hs('联系我们', 'Contact Us') }}</div>
            </div>
          </div>
          <div class="btn" @click="$router.push('/cart')">
            <div class="msg cart">
              <i class="icon-hsrj icon-gouwuche-wu">
                <div class="cart-num">{{ userInfo.id ? gettingCart.length : getEnquiry[0].list.length }}</div>
              </i>
              <div>{{ $hs('购物车', 'Cart') }}</div>
            </div>
          </div>
          <div class="btn" @click="goPersonal">
            <div class="msg">
              <i class="el-icon-user"></i>
              <div>
                {{ $hs('个人中心','Personal') }}
                <br />
                {{ $hs('','Center') }}
              </div>
            </div>
          </div>
          <div class="btn" @click="onScrollTop">
            <div class="msg">
              <i class="el-icon-top"></i>
              <div>{{ $hs('返回顶部','Back to top') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>-->
    <login-modal ref="loginModal" @register="register"></login-modal>
    <register-model ref="registerModel" @login="login"></register-model>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { ProductClassWebGetTree, SysWebSiteConfigGetDetail } from '@/api/home'
import loginModal from '@/components/memberModal/loginModal.vue'
import registerModel from '@/components/memberModal/registerModel.vue'
import layoutHeader from './layoutHeader'
import layoutFooter from './layoutFooter.vue'
export default {
  name: 'pcLayout',
  components: {
    layoutHeader,
    layoutFooter,
    loginModal,
    registerModel
  },
  data() {
    return {
      drawer: false,
      isLeftIndex: null,
      isRightIndex: null,
      classifyValue: '',
      setMenusData: [],
      setMenusDataOld: [],
      openeds: [],
    }
  },

  created() {
    this.init()
  },

  computed: {
    ...mapState('operate', ['language']),
    ...mapState('user', ['userInfo']),
    ...mapGetters('operate', {
      gettingCart: 'getting_cart',
      getEnquiry: 'get_enquiry'
    }),
    key() {
      this.$route.path
    }
  },

  methods: {
    ...mapActions('setting', {
      setMenus: 'set_menus',
      setLanguageConfig: 'set_language_config'
    }),
    ...mapActions('operate', {
      setLanguage: 'set_language'
    }),
    async init() {
      // 站点语言
      await SysWebSiteConfigGetDetail()
        .then(res => {
          if (res.success) {
            this.setLanguageConfig(res.data)
            if (!window.localStorage.getItem('i18n')) {
              if (res.data.defaultLanguage === 'zh-Hans') {
                this.setLanguage('zh')
                window.location.reload()
              } else {
                this.setLanguage(res.data.defaultLanguage)
                window.location.reload()
              }
            }
          } else {
            this.$message(res.message)
          }
        })
        .catch(err => {
          this.$message({ err })
        })

      await ProductClassWebGetTree()
        .then(res => {
          if (res.success) {
            this.setMenus(res.data)
            this.setMenusData = res.data
            this.setMenusDataOld = res.data

            this.openeds = res.data.map((item, index) => {
              return String(item.cl_Nu)
            })
          } else {
            this.$message(res.message)
          }
        })
        .catch(err => {
          this.$message({ err })
        })
    },
    // 登录
    login() {
      this.$refs.loginModal.open()
    },

    // 注册
    register() {
      this.$refs.registerModel.open()
    },
    goPersonal() {
      if (this.userInfo.id) {
        this.$router.push('/personal')
      } else {
        this.login()
      }
    },

    // 定义一个递归函数来筛选树形数据
    filterTreeData(data, searchText) {
      return data.filter(node => {
        let isMatch = false
        if (this.$hs('zh', 'en', 'es') === 'zh') {
          isMatch = node.cl_Na ? node.cl_Na.includes(searchText) : false
        } else if (this.$hs('zh', 'en', 'es') === 'en') {
          isMatch = node.cl_Ne_Na
            ? node.cl_Ne_Na.toUpperCase().includes(searchText.toUpperCase())
            : false
        } else if (this.$hs('zh', 'en', 'es') === 'es') {
          isMatch = node.threeLanguage
            ? node.threeLanguage.includes(searchText)
            : false
        }
        if (isMatch) {
          return true
        }
        if (node.children) {
          node.children = this.filterTreeData(node.children, searchText)
          return node.children.length > 0
        }

        return false
      })
    },
    onScrollTop() {
      document.documentElement.scrollTop = 0
    }
  }
}
</script>
<style lang="scss" scoped>
.el-header,
.el-footer,
.el-main {
  padding: 0;
}

:deep .container {
  width: 1200px; //one模板
}

.el-main {
  min-height: 400px;
}

.class-nav {
  position: fixed;
  top: 45%;
  left: -58px;
  z-index: 99;
  width: 160px;
  height: 50px;
  line-height: 60px;
  text-align: center;
  font-size: 18px;
  background-color: #fab728;
  transform: rotate(90deg);
  border-radius: 10px 10px 0 0;
  color: #fff;
  letter-spacing: 1.8px;
  cursor: pointer;
  &:hover {
    font-size: 20px;
  }
  .el-icon-arrow-up {
    display: inline-block;
    position: absolute;
    top: 0px;
    left: 48%;
  }
}

:deep(.class-drawer) {
  width: auto !important;
  background-color: transparent !important;

  .nav-menu {
    display: flex;
    flex-direction: column;
    width: 380px;
    height: 100%;
    background: #f4f4f4;
    .input-box {
      width: 320px;
      margin: 20px auto;
      .el-input-group {
        border-radius: 5px !important;
        overflow: hidden;
        border: 1px solid #00923f;
        height: 34px;
        .el-input__inner {
          border: 0 !important;
          font-size: 14px;
        }

        .el-input-group__append {
          border: none;
          width: 80px;
          height: 34px;
          background: #00923f;
          text-align: center;
          font-size: 14px;
          box-sizing: border-box;
          color: #fff;
          cursor: pointer;
        }
      }
    }
    .menu-box {
      height: calc(100vh - 76px);
      overflow-y: auto;

      .el-submenu__title i {
        color: #000;
        font-size: 18px;
        font-weight: 700;
      }
      .el-submenu__title {
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        font-weight: bold;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        background-color: #f4f4f4;
        .el-icon-folder {
          // color: #222;
          font-size: 16px;
          font-weight: bold;
        }
        &:hover {
          background-color: #e3ebff;
        }
        & > span {
          display: inline-block;
          width: 280px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .second-level {
        font-weight: normal !important;
        color: #555 !important;
        font-size: 14px !important;
        &.is-active {
          color: #00923f !important;
          background-color: #e3ebff !important;
          .icon {
            border: 2px solid #00923f !important;
          }
        }
      }
      .icon {
        height: 12px;
        width: 14px;
        border-radius: 50%;
        border: 2px solid #999;
        margin: 0 10px 0 0;
        box-sizing: border-box;
      }

      .el-menu-item {
        display: flex;
        align-items: center;
        color: #222;
        font-weight: bold;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        background-color: #f4f4f4;
        .el-icon-folder {
          // color: #222;
          font-size: 16px;
          font-weight: bold;
        }
        &.is-active {
          color: #00923f;
          background-color: #e3ebff;
          .icon {
            border: 2px solid #00923f;
          }
        }
        &:hover {
          background-color: #e3ebff;
        }
        & > span {
          display: inline-block;
          width: 300px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
.tab-left {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.audita-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}

.fixed-box {
  display: flex;
  justify-content: center;
  position: fixed;
  top: 400px;
  margin: auto;
  width: 100%;
  padding: 5px;

  .fixed {
    position: relative;
    width: 1200px;
    .side-fixed {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      position: absolute;
      top: 0;
      right: -120px;
      height: 320px;
      // box-shadow: 0 0 10px 2px #eee;
      border: 1px solid #f5f5f5;
      background-color: #eee;
      .btn {
        width: 80px;
        height: 80px;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #999999;
        cursor: pointer;
        // overflow: hidden; /* 确保超出的内容被裁剪 */
        // white-space: nowrap; /* 确保文本在一行内显示 */
        // text-overflow: ellipsis; /* 使用省略号表示超出的文本 */
        .cart {
          position: relative;
          padding: 0 5px 0;
          margin: 10px 0 0 0;

          .cart-num {
            display: inline-block;
            position: absolute;
            z-index: 99;
            top: -5px;
            height: 18px;
            line-height: 18px;
            background-color: #00923f;
            border-radius: 8px;
            font-size: 12px;
            padding: 0px 5px;
            color: #fff;
            font-weight: normal;
          }
        }

        .msg {
          display: flex;
          flex-direction: column;
          align-items: center;
          i {
            font-size: 30px;
            color: #00923f;
          }
          & > div {
            font-size: 12px;
            text-align: center;
          }
        }

        &:hover {
          background-color: #eee;
          color: #00923f;
        }
        :deep .el-popover__reference-wrapper {
          width: 100%;
          height: 100%;
          .el-popover__reference {
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }
  }
}
</style>